import React, { useEffect, useState } from 'react';
import { ROLE_IMG } from '../utils/roleAssets';
import './RoleIllustration.css';

/**
 * @param {'farmer'|'consumer'} role
 * @param {boolean} [rotateConsumer] — alternate male/female every 3s (consumer only)
 * @param {string} [gender] — consumer profile gender ('male' | 'female' | 'other' | '')
 * @param {boolean} [strictConsumerGender] — when true, only show male/female art for those values; otherwise no image
 * @param {'xs'|'sm'|'md'|'lg'|'fill'} [size]
 */
const RoleIllustration = ({
  role,
  rotateConsumer = false,
  gender,
  strictConsumerGender = false,
  className = '',
  size = 'md'
}) => {
  const [femaleIndex, setFemaleIndex] = useState(0);

  useEffect(() => {
    if (!rotateConsumer || role !== 'consumer') return undefined;
    const id = setInterval(() => setFemaleIndex((i) => (i + 1) % 2), 3000);
    return () => clearInterval(id);
  }, [rotateConsumer, role]);

  if (role !== 'farmer' && role !== 'consumer') return null;

  let src = null;
  if (role === 'farmer') {
    src = ROLE_IMG.farmer();
  } else if (rotateConsumer) {
    src = femaleIndex === 1 ? ROLE_IMG.consumerFemale() : ROLE_IMG.consumerMale();
  } else if (strictConsumerGender) {
    const g = String(gender || '').toLowerCase();
    if (g === 'female') src = ROLE_IMG.consumerFemale();
    else if (g === 'male') src = ROLE_IMG.consumerMale();
  } else {
    src = ROLE_IMG.consumerMale();
  }

  if (!src) return null;

  return (
    <img
      src={src}
      alt=""
      role="presentation"
      className={`role-illustration role-illustration--${size} ${className}`.trim()}
    />
  );
};

export default RoleIllustration;
